import React from 'react';
import IntramuralCalendar from './IntramuralCalendar';
import './Intramurals.css';
import { halloffame } from "../content";

function Intramurals() {
  return (
    <section id="events">
      <div className="fade-in">

        {/* Hero Banner */}
        <div className="intramurals-image">
          <img src="/images/intramurals.jpg" alt="Intramurals Banner" />
          <div className="hero-text">
            <h1 className="title">Intramurals Schedule</h1>
            <p className="intramurals-description">
              Every quarter we participate in various intramural sports including football,
              basketball, volleyball, futsal, softball, and kickball. Sign-up info will be
              posted in Slack before each quarter. Check the calendar and hall of fame below!
            </p>
          </div>
        </div>

        {/* Calendar Section */}
        <div className="calendar-container">
          <IntramuralCalendar />
        </div>

        {/* Hall of Fame Section */}
        <div className="hall-of-fame-section">
          <div className="w-full text-center mb-8">
            <h2 className="hall-of-fame-title">🏆 Hall of Fame 🏆</h2>
          </div>
          <div id="hall-of-fame">
            {halloffame.map((entry, index) => (
              <div key={index} className="hof-card">
                <div className="hof-image-wrapper">
                  <img
                    src={entry.image}
                    alt={entry.name}
                    className="hof-image"
                  />
                </div>
                <div className="hof-name">{entry.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intramurals;
